__webpack_require__.p = "/monitor-static/";